module.exports = __webpack_public_path__ + "img/Passives_16.e17e17c3.png";